import { useState } from "react";
import { formatVND } from "../contants/formatVND";
import { getUserStatus, cleanUrl } from "../contants";
import greenStick from "../assets/icon/green_stick.png";
import unavail from "../assets/icon/stock_unavailable2.png";

interface ProductItem {
  id: string;
  productName: string;
  image?: string | null;
  price: number;
  stockQuantity?: number | string;
}

const FALLBACK_IMAGE = "/no-image.jpg";

export default function ProductCard({ item }: { item: ProductItem }) {
  const cleanedImage = cleanUrl(item?.image || "");
  const initialSrc =
    cleanedImage && cleanedImage.trim() !== "" ? cleanedImage : FALLBACK_IMAGE;
  const [imgSrc, setImgSrc] = useState(initialSrc);

  const role = getUserStatus();

  const hasStock =
    item?.stockQuantity !== undefined && Number(item?.stockQuantity) > 0;

  return (
    <article className=" group relative overflow-hidden rounded-2xl border border-slate-100 shadow-lift transition-transform duration-300 hover:-translate-y-1">
      <div className="relative aspect-[4/5] overflow-hidden">
        <a href={`/chi-tiet-san-pham/${item?.id}`} className="block h-full">
          <img
            loading="lazy"
            width={260}
            height={300}
            src={imgSrc}
            className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
            alt={item?.productName}
            onError={() => setImgSrc(FALLBACK_IMAGE)}
          />
        </a>

        <div className="absolute left-3 top-3 flex items-center gap-2">
          <span
            className={`rounded-full px-3 py-1 text-xs font-semibold ${
              hasStock
                ? "bg-emerald-50 text-emerald-700"
                : "bg-rose-50 text-rose-700"
            }`}
          >
            {hasStock ? "Còn hàng" : "Hết hàng"}
          </span>
          <img
            src={hasStock ? greenStick : unavail}
            alt={hasStock ? "Còn hàng" : "Hết hàng"}
            className="h-4 w-4"
          />
        </div>
      </div>

      <div className="space-y-3 px-4 pb-4 pt-3">
        <h4 className="min-h-[48px] text-sm font-semibold text-slate-900">
          <a
            href={`/chi-tiet-san-pham/${item?.id}`}
            className="transition hover:text-indigo-700"
          >
            {item?.productName}
          </a>
        </h4>

        <div className="flex items-center justify-between">
          <span className="text-lg font-bold text-indigo-700" style={{color: "rgb(36 139 202)"}}>
            {formatVND(item?.price)}
          </span>
        </div>

        <div className="flex items-center justify-between text-xs font-semibold">
          {role ? (
            <p className="text-emerald-700" style={{color: "rgb(104 102 133)"}}>{}</p>
          ) : (
            <a
              target="_blank"
              rel="noreferrer"
              title="Đăng nhập để xem giá đại lý"
              href="/dang-nhap"
              className="text-indigo-700 underline underline-offset-4 transition hover:text-indigo-500"
              style={{color: "rgb(136 136 136)"}}
            >
              Đăng nhập để xem giá đại lý
            </a>
          )}
        </div>
      </div>
    </article>
  );
}
